import { toast } from "react-toastify";

interface TemplateForm {
  recipientName: string;
  daysRemaining: string;
  fundraisingPurpose: string;
  numberOfPeople: string;
  donationAmount: string;
  fundraisingGoal: string;
  accomplishment: string;
  fundraiserLink: string;
  userName: string;
}

export class SocialTemplateService {
  static generateMessage(data: TemplateForm): string {
    return `Dear ${data.recipientName},\n\nI only have ${data.daysRemaining} days to finish fundraising for ${data.fundraisingPurpose}.\n\nIf only ${data.numberOfPeople} of people donated ${data.donationAmount} to my fundraiser, I would ${data.fundraisingGoal}. Would you be able to help make this a reality?\n\nTo donate, just click the link to my fundraiser below:\n\n${data.fundraiserLink}\n\nIt would also really help if you could share my fundraiser link with everyone you know. The more eyes on my fundraiser, the better!\n\nI appreciate all of your support! I wouldn't be able to accomplish ${data.accomplishment} without your help.\n\n${data.userName}`;
  }

  static async copyToClipboard(message: string): Promise<boolean> {
    try {
      await navigator.clipboard.writeText(message);
      return true;
    } catch (error) {
      console.error('Failed to copy message to clipboard:', error);
      return false;
    }
  }

  static shareToWhatsApp(message: string): void {
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  }

  static shareToInstagramStory(message: string): void {
    toast.info("Instagram does not support direct web sharing to stories with text. The message has been copied to your clipboard. Please open Instagram and paste it into your story.");
    this.copyToClipboard(message);
    // window.open("https://instagram.com", "_blank");
  }

  static shareToInstagramUser(message: string): void {
    toast.info(`Instagram does not support direct web sharing to DMs with text. The message has been copied to your clipboard. Please open Instagram and DM the user you want to share with.`);
    this.copyToClipboard(message);
    // window.open(`https://instagram.com/direct/inbox/`, "_blank");
  }

  static shareToX(message: string): void {
    const encodedMessage = encodeURIComponent(message);
    const tweetUrl = `https://twitter.com/intent/tweet?text=${encodedMessage}`;
    window.open(tweetUrl, "_blank");
  }

  static shareToXDM(message: string): void {
    toast.info(`Twitter/X does not support direct web sharing to DMs with text. The message has been copied to your clipboard. Please open X and DM the user you want to share with.`);
    this.copyToClipboard(message);
    window.open(`https://twitter.com/messages/compose?recipient_id=`, "_blank");
  }

  static getFundraisingOptions(): string[] {
    return [
      "a new computer",
      "medical expenses",
      "education fees",
      "emergency fund",
      "business startup",
      "home renovation",
      "travel expenses",
      "sports equipment",
      "wedding ceremony",
      "pet medical bills",
      "community project",
      "charity donation",
    ];
  }
}

export type { TemplateForm };